<template>
    <div class=category-list>
        <div class="module-item-style reply-filter">
            <el-select v-model="category" placeholder="请选择" class="select-type" @change="filterList">
                <el-option
                        label="全部分类"
                        value="">
                </el-option>
                <el-option
                        v-for="item in categoryList"
                        :key="item.type"
                        :label="item.label"
                        :value="item.type">
                </el-option>
            </el-select>
            <el-input placeholder="请输入分类名称" v-model="searchCategory" class="input-search-problem">
                <el-button slot="append" icon="el-icon-search" @click="filterList"></el-button>
            </el-input>
        </div>
        <div class="module-item-style">
            <tableMulti
                    :tableData="tableData"
                    :tableHead="tableHead"
                    :tableHandler="tableHandler"
                    :total="total"
                    :size="pageSize"
                    @handleButton="handleOperate"
                    @pageHandler="pageOperate"></tableMulti>
        </div>

    </div>
</template>

<script>
    import tableMulti from '@/components/table/table-multi'
    export default {
        name: "category-list",
        components:{
            tableMulti
        },
        data() {
            return {
                category:'',
                categoryList:[],
                searchCategory:'',
                currentPage: 1,
                pageSize:10,
                tableHandler:[
                    {label:"编辑",type:'edit',methods:'editMethods'},
                    {label:"删除",type:'del',methods:'delMethods'},
                ],
                tableData:[],
                tableHead:[
                    {
                        label: '分类名称',
                        value: 'groupName',
                        operate:false
                    },{
                        label: '分类',
                        value: 'groupTypeStr',
                        operate:false
                    },{
                        label: '操作',
                        value: '',
                        width:'160',
                        operate:true,
                    }
                ],
                total: 0
            }
        },
        created() {
            this.getCategoryType()
        },
        mounted() {
            eventBus.$on('reloadCategoryTable',() => {
                this.getCategoryData()
            })
        },
        methods: {
            /**
             * 表单操作
             * @param val
             */
            handleOperate(val){
                console.log(val)
                let delData = []
                if(val.methods == "delMethods"){
                    this.delCategory(val.row.id)
                }else if(val.methods == 'delAll'){
                    if(val.row.length == 0){
                        this.$message({
                            showClose: true,
                            message: '请勾选要删除的二维码名片',
                            type: 'error',
                            duration: 3 * 1000
                        })
                        return false
                    }
                    val.row.map((item) => {
                        delData.push(item.id)
                    })
                    this.delSomeReplyContent(delData)
                }else if(val.methods == 'editMethods'){
                    eventBus.$emit('editReplyCategory',val.row)
                }
                // this.delFile(delData)
            },
            /**
             *  分页操作
             * @param val
             */
            pageOperate(val){
                if(val.type == 'currentChange'){
                    this.currentPage = val.val
                }else if(val.type == "sizeChange"){
                    this.pageSize = val.val
                }
                this.getCategoryData()
            },
            /**
             * 获取分类列表
             */
            getCategoryData(){
                this.$http.getCategoryListAPI({
                    type:this.category,
                    pageSize:this.pageSize,
                    pageNum:this.currentPage,
                    qrGroupName:this.searchCategory
                }).then( res => {
                    if(res.status == 1){
                        let cData = res.data.list

                        cData.map( item => {
                            if(item.groupType == 1){
                                item.groupTypeStr = '个人回复'
                            }else if(item.groupType == 2){
                                item.groupTypeStr = '企业回复'
                            }
                        })

                        this.tableData = cData
                        this.total = res.data.total
                    }
                })
            },
            getCategoryType(){
                this.$http.getCategoryTypeAPI().then( res => {
                    if(res.status == 1){
                        this.categoryList = res.data
                        // this.category = res.data[0].type
                        this.$nextTick(() => {
                            this.getCategoryData()
                        })
                    }

                })
            },
            filterList(){
                this.currentPage = 1
                this.getCategoryData()
            },
            delCategory(id){
                this.$http.delCategoryDataAPI({
                    classId:id
                }).then( res => {
                    if (res.status == 1) {
                        this.getCategoryData()
                        this.$message({
                            message: res.msg,
                            type: 'success'
                        })
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error'
                        })
                    }
                })
            },
            delSomeReplyContent(data) {
                this.$http.delSomeCategoryContentAPI({
                    replayIds: data
                }).then(res => {
                    if (res.status == 1) {
                        this.getCategoryData()
                        this.$message({
                            message: res.msg,
                            type: 'success',
                        })
                    } else {
                        this.$message({
                            message: res.msg,
                            type: 'error',
                        })
                    }
                })
            }
        },
    }
</script>

<style lang="scss">
    .category-list {
        .reply-filter{
            display: flex;
            .input-search-problem{
                width: 300px;
                margin-left: 20px;
            }
        }
    }
</style>